import { PBox } from "../../theme/BaseTheme";
import { FeatureImageLeft } from "../../sections/FeatureImageLeft";
import { FeatureImageRight } from "../../sections/FeatureImageRight";
import { SellFaq } from "../../sections/SellFaq";
import UseCases from "../../sections/UseCases";

const disney_filter_faq_data = [
    {
        question: "What is the Disney Filter, and how does it work?",
        answer: "The Disney filter is an advanced AI that takes photos and makes them look like Disney pictures by using their classic animation theme.",
    },
    {
        question: "Do I need any special skills to use the Disney Filter?",
        answer: "Filter is designed for beginners, so it's simple to use. The interface is thoughtfully designed to allow everyone to use this tool regardless of their experience with image editing.",
    },
    {
        question: "What types of photos work best with the Disney Filter?",
        answer: "The Disney filter works particularly well with portraits, pet photos, landscapes, and all other types of images.",
    },
    {
        question: "What about privacy? Are my photos safe?",
        answer: "Yes, your images are safe with us. Patternful.ai prioritizes user data safety. Your images are always private, proprietary, and they remain your property. All your uploaded images are automatically deleted from our servers after a few hours.",
    },
];

const disney_filter_use_cases = [
    {
        title: "Social Media",
        description:
            "Post your Disney-inspired creations on Instagram, Facebook, and more. Get noticed with incredible magical content that makes your followers happy.",
        image: "/images/image-filters/disney-filter-5.webp",
    },
    {
        title: "Illustration Design",
        description:
            "Create some incredible Disney-inspired creations for personal or professional projects. Great for illustrators, designers, and hobbyists who just want to add a magical touch to your pictures.",
        image: "/images/image-filters/disney-filter-6.webp",
    },
    {
        title: "Generate Anime Character",
        description:
            "Create hybrid characters integrating Disney aesthetics with anime styles using the Disney Pixar Filter. Perfect for storytellers and digital artists, It works for you if you want to create anime-like characters from your pictures for some personal project or story.",
        image: "/images/image-filters/disney-filter-7.webp",
    },
];

const DisneyFilter = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/image-filters/disney-filter-1.webp"}
                title={
                    "Convert Selfies into Disney Characters with Princess Filter"
                }
                description={
                    "The Disney Princess Filter helps you to unlock your inner royalty, by simply turning selfies into amazing Disney-style characters. This tool is perfect for fans of classic animated films, in which your portraits bring the magic. Our Disney AI filter uses precise facial analysis to apply the proper personal touch to every image, whilst defining the official Disney animation style. This makes for great social media posts, profile pictures, or even a keepsake memento. You too can take a few steps into the world of Disney with a few simple clicks."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/disney-filter-2.webp"}
                title={"Turn Your Pets into Disney Cartoons"}
                description={
                    "For some reason, you have ever wondered what your furry friend would look like as a Disney character. Star with your dog, cat, or any beloved pet to life with Disney filter pets. This fun and inventive feature makes for wonderful keepsakes, good entertainment for your followers on social media, or simply cute to watch your pet in cartoon form. The Disney AI cartoon filter captures their personality exactly and adds just a touch of Disney magic."
                }
            />
            <FeatureImageLeft
                image={"/images/image-filters/disney-filter-3.webp"}
                title={
                    "Turn any Breathtaking Landscape into a location from a Disney movie"
                }
                description={
                    "Use the Disney filter to take your travel photo game up to the next level. The tool, whether it's a quiet beach, a serene forest, or a bustling cityscape, can turn it into a Disney-style scene. This feature is a great way to make boring photos cool. The filter makes colors, textures, and lighting better to give you the same feeling as the classic Disney movies. Pictures will take you all over the enchanted forests to royal castles."
                }
            />
            <FeatureImageRight
                image={"/images/image-filters/disney-filter-4.webp"}
                title={"Create Stunning Disney Style Illustrations"}
                description={
                    "The Disney AI filter allows you to bring your creative visions to life. This tool can turn photos into high-quality Disney-inspired artwork for use on a personal art project or for an illustration you are painting for a client. It's the attention to detail from the AI that makes it such a favorite for illustrators, graphic designers, and hobbyists alike, as it leaves a professional finish. Creating polished, cartoon-like visuals has never been easier in a matter of seconds with no advanced editing skills."
                }
            />
            <UseCases
                data={disney_filter_use_cases}
                title={"Creative and Pretty Disney Filters for Everyone"}
            />
            <SellFaq data={disney_filter_faq_data} />
        </PBox>
    );
};

export default DisneyFilter;
